document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.selfco-header');
  const mobileToggle = document.getElementById('selfco-mobile-toggle');
  const mobileClose = document.getElementById('selfco-mobile-close');
  const mobileMenu = document.getElementById('selfco-mobile-menu');
  const langToggle = document.getElementById('mobile-lang-toggle');
  const langDropdown = document.getElementById('mobile-lang-dropdown');
  const productsToggle = document.getElementById('mobile-products-toggle');
  const productsDropdown = document.getElementById('mobile-products-dropdown');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileMenu) {
    mobileClose.addEventListener('click', function() {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  if (langToggle && langDropdown) {
    langToggle.addEventListener('click', function() {
      const isOpen = langDropdown.classList.toggle('is-open');
      langToggle.classList.toggle('is-open', isOpen);
    });
  }

  if (productsToggle && productsDropdown) {
    productsToggle.addEventListener('click', function() {
      productsDropdown.classList.toggle('is-open');
      const chevron = productsToggle.querySelector('.selfco-header__chevron');
      if (chevron) {
        chevron.style.transform = productsDropdown.classList.contains('is-open') ? 'rotate(180deg)' : '';
      }
    });
  }

  if (header) {
    header.addEventListener('click', function(e) {
      if (!e.target.closest('.selfco-header__dropdown')) {
        header.querySelectorAll('.selfco-header__dropdown[open]').forEach(function(d) {
          d.removeAttribute('open');
        });
      }
    });

    // Smart sticky: hide on scroll down, show on scroll up (mobile only)
    let lastScrollY = window.scrollY;
    let ticking = false;

    function updateHeader() {
      const currentScrollY = window.scrollY;
      const isMobile = window.innerWidth <= 989;

      if (isMobile && currentScrollY > 80) {
        if (currentScrollY > lastScrollY) {
          header.classList.add('is-hidden');
        } else {
          header.classList.remove('is-hidden');
        }
      } else {
        header.classList.remove('is-hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }
});
